//@flow

import React from 'react';
import NavigateLink from 'app/common/react/ui/NavigateLink';
import { track } from 'app/common/lib/react/analytics';
import { Avatar, Box } from 'gestalt';

type Props = {|
  avatarUrl: string,
  isHorizontalDesign: boolean,
  isVerified: boolean,
  url: string,
  userFullName: string,
  viewType: $Values<PCONST.thrift.ViewType>,
  viewParameter: $Values<PCONST.thrift.ViewParameterType>,
|};

function trackProfileClick(
  viewType: $Values<PCONST.thrift.ViewType>,
  viewParameter: $Values<PCONST.thrift.ViewParameterType>,
) {
  track(PCONST.thrift.EventType.CLICK, {
    view: viewType,
    viewParameter,
    component: PCONST.thrift.ComponentType.AVATAR_HOVER_CARD,
    element: PCONST.thrift.ElementType.AVATAR_HOVER_CARD_AVATAR,
  });
}

const AvatarHoverCardAvatar = (props: Props) => {
  const {
    avatarUrl,
    isVerified,
    isHorizontalDesign,
    url,
    userFullName,
    viewParameter,
    viewType,
  } = props;
  const avatarSizePixels = isHorizontalDesign ? 80 : 86;

  return (
    <Box
      dangerouslySetInlineStyle={{
        __style: {
          border: '2px white solid',
          marginTop: isHorizontalDesign ? -58 : -64,
          marginLeft: isHorizontalDesign ? -6 : 0,
          zIndex: 1,
        },
      }}
      display="flex"
      flex="none"
      shape="circle"
    >
      <Box flex="none" height={avatarSizePixels} width={avatarSizePixels}>
        <NavigateLink onClick={trackProfileClick(viewType, viewParameter)} to={url} stopPropagation>
          <Avatar name={userFullName} src={avatarUrl} verified={isVerified} />
        </NavigateLink>
      </Box>
    </Box>
  );
};

export default AvatarHoverCardAvatar;
